import ApiService from "@/common/api.service";

const getBase64Payload = (response) => response?.data?.data ?? response?.data ?? response;

export const normalizeObjectPath = (path) => {
  if (!path) return null;
  const trimmedPath = String(path).trim();
  if (!trimmedPath) return null;

  let objectPath = trimmedPath;
  try {
    const url = new URL(trimmedPath);
    objectPath = url.pathname;
  } catch (error) {
    objectPath = trimmedPath;
  }

  objectPath = objectPath.replace(/[?#].*$/, "").replace(/^\/+/, "");
  const publicIndex = objectPath.indexOf("public");
  return publicIndex >= 0 ? objectPath.substring(publicIndex) : objectPath;
};

export const toSecureUrl = (url) => {
  if (!url) return url;
  return url.startsWith("http://") ? url.replace("http://", "https://") : url;
};

export async function getPresignedUrl(path, {preferHttps = false, allowInsecure = true, toast} = {}) {
  const objectPath = normalizeObjectPath(path);
  if (!objectPath) return null;
  try {
    const {data} = await ApiService.post("/files/presign", {
      path: objectPath,
      expiresIn: 900,
    });
    const url = data?.data?.url;
    const secureUrl = preferHttps ? toSecureUrl(url) : null;
    return secureUrl || (allowInsecure ? url : null);
  } catch (error) {
    toast?.error?.("Unable to fetch file link. Please try again.");
    return null;
  }
}

export async function openPresignedUrl(path, options = {}) {
  const url = await getPresignedUrl(path, options);
  if (url) {
    window.open(url, "_blank");
  }
}

export const getMimeTypeFromUrl = (url) => {
  if (!url) return "image/jpeg";
  const cleanUrl = String(url).split(/[?#]/)[0];
  const ext = cleanUrl.split(".").pop()?.toLowerCase();
  switch (ext) {
    case "png":
      return "image/png";
    case "gif":
      return "image/gif";
    case "webp":
      return "image/webp";
    default:
      return "image/jpeg";
  }
};

export async function fetchImageAsDataUrl(url, fetchImage) {
  if (!url || typeof fetchImage !== "function") return null;
  try {
    const response = await fetchImage(url);
    const base64 = getBase64Payload(response);
    if (!base64) return null;
    const mimeType = getMimeTypeFromUrl(url);
    return base64.startsWith("data:")
        ? base64
        : `data:${mimeType};base64,${base64}`;
  } catch (error) {
    return null;
  }
}

export async function buildPreviewUrl(path, {preferHttps = false, allowInsecure = true, toast, fetchImage} = {}) {
  const rawUrl = await getPresignedUrl(path, {preferHttps, allowInsecure, toast});
  if (!rawUrl) return null;
  if (rawUrl.startsWith("https://") || !fetchImage) {
    return rawUrl;
  }
  if (rawUrl.startsWith("http://")) {
    const dataUrl = await fetchImageAsDataUrl(path, fetchImage);
    if (dataUrl) return dataUrl;
  }
  return rawUrl;
}
